import { BreadcrumbTheme } from '@medly-components/theme';

import colors from './colors';

export const breadcrumb: BreadcrumbTheme = {
    textColor: {
        default: colors.darkBlue,
        hovered: colors.darkBlue,
        disabled: colors.grey[400]
    }
};
